import { RecipientContainer, SharingLinkInfo } from 'owa-link-data';
import { trace } from 'owa-trace';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Editor } from 'roosterjs-editor-core';
import { updateComposeLinkViewState } from '../actions/internalActions';
import getComposeLinkViewState from '../selectors/getComposeLinkViewState';
import getText from '../utils/getText';
import { getDisplayName } from '../utils/link/getDisplayName';
import { getFileIcon } from '../utils/link/getFileIcon';
import { Link } from './Link';

export function createSharingLinkView(
    editor: Editor,
    getRecipientWells: () => RecipientContainer[],
    fromAddress: string,
    composeId: string,
    originalElement: HTMLElement,
    sharingLinkInfo: SharingLinkInfo,
    sharingLinkInfoHasValidFileName: boolean,
    shouldBeautify: boolean,
    isLinkPreviouslyBeautified: boolean
) {
    trace.info(
        'createSharingLinkView for id=${originalElement.id} isLinkPreviouslyBeautified=${isPreviouslyBeautified}`'
    );

    const shouldShowBeautifiedLink = shouldBeautify || isLinkPreviouslyBeautified;
    const hasValidFileName = sharingLinkInfoHasValidFileName || isLinkPreviouslyBeautified; // Previous beautified link has the file name as the inner text

    // to get the file icon, use the original name that came from the response, as the text filename could have been modified for display
    const fileIcon = getFileIcon(
        isLinkPreviouslyBeautified ? getText(originalElement) : sharingLinkInfo.fileName,
        shouldShowBeautifiedLink,
        sharingLinkInfo.mimeType
    );

    const anchorContainer = document.createElement('span');
    const displayName = getDisplayName(
        originalElement,
        sharingLinkInfo,
        hasValidFileName,
        shouldBeautify,
        isLinkPreviouslyBeautified
    );

    updateComposeLinkViewState(sharingLinkInfo.linkId, displayName, shouldShowBeautifiedLink);

    ReactDOM.render(
        <Link
            viewState={getComposeLinkViewState(sharingLinkInfo.linkId)}
            getRecipientWells={getRecipientWells}
            fromAddress={fromAddress}
            sharingLink={sharingLinkInfo}
            fileIcon={fileIcon}
            hasValidFileName={hasValidFileName}
            editor={editor}
            originalElement={originalElement}
            composeId={composeId}
            isLinkPreviouslyBeautified={isLinkPreviouslyBeautified}
        />,
        anchorContainer
    );
}
